import { createSlice } from '@reduxjs/toolkit'

type dialogState = {
  boolean: boolean
  booleanApiQr: boolean
  booleanQr: boolean
  booleanQrFinish: boolean
  booleanKey: boolean
  stateKeyWord: string
  dialogPointState: boolean
  dialogFarSpotState: boolean
}

const initialState: dialogState = {
  boolean: true,
  booleanQr: true,
  booleanApiQr: false,
  booleanKey: true,
  booleanQrFinish: true,
  stateKeyWord: '',
  dialogPointState: true,
  dialogFarSpotState: true,
}

const dialogReducer = createSlice({
  name: 'dialog',
  initialState: initialState,
  reducers: {
    dialogState(state, action) {
      state.boolean = action.payload
    },
    dialogStateQr(state, action) {
      state.booleanQr = action.payload
    },
    stateApiQr(state, action) {
      state.booleanApiQr = action.payload
    },
    stateKeyWord(state, action) {
      state.stateKeyWord = action.payload
    },
    dialogStateQrFinish(state, action) {
      state.booleanQrFinish = action.payload
    },
    dialogStateKey(state, action) {
      state.booleanKey = action.payload
    },
    dialogPointReducer(state, action) {
      state.dialogPointState = action.payload
    },
    dialogFarSpotReducer(state, action) {
      state.dialogFarSpotState = action.payload
    },
  },
})

export const {
  dialogState,
  dialogStateQr,
  stateApiQr,
  stateKeyWord,
  dialogStateQrFinish,
  dialogStateKey,
  dialogPointReducer,
  dialogFarSpotReducer,
} = dialogReducer.actions

export default dialogReducer.reducer
